import { v4 } from 'uuid';

const SEARCH_SYNC_WITH_LOCATION = 'SEARCH_SYNC_WITH_LOCATION';
const SEARCH_ITEM_ADD = 'SEARCH_ITEM_ADD';
const SEARCH_ITEMS_ADD = 'SEARCH_ITEMS_ADD';
const SEARCH_ITEMS_LOAD = 'SEARCH_ITEMS_LOAD';
const SEARCH_ITEMS_LOADING = 'SEARCH_ITEMS_LOADING';
const SEARCH_ITEMS_LOADED = 'SEARCH_ITEMS_LOADED';
const SEARCH_ITEMS_LOAD_FAILED = 'SEARCH_ITEMS_LOAD_FAILED';
const SEARCH_SET_ID = 'SEARCH_SET_ID';

export const initialState = {
  loading: false,
  page: 1,
  sort: '',
  items: [],
  known: {},
  id: null
};
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SEARCH_SET_ID: {
      return {
        ...state,
        id: action.payload
      };
    }
    case SEARCH_SYNC_WITH_LOCATION: {
      const { items: stateItems = [] } = state;
      const { items: payloadItems, params } = action.payload;

      if (!payloadItems.length) {
        return {
          ...state,
          page: ~~params.page || 1,
          sort: params.sort,
          items: []
        };
      }
      const stateItemsMap = stateItems.reduce((acc, curr) => {
        acc[`${curr.type}=${curr.slug}`] = true;
        return acc;
      }, {});

      const payloadItemsMap = payloadItems.reduce((acc, curr) => {
        acc[`${curr.type}=${curr.slug}`] = curr;
        return acc;
      }, {});

      const cacheItems = stateItems.map((item) => {
        const { type, slug } = item;
        const cacheKey = `${type}=${slug}`;

        if (!state.known[cacheKey] || !payloadItemsMap[cacheKey]) {
          return null;
        }

        return {
          ...state.known[cacheKey],
          ...item,
          ...payloadItemsMap[cacheKey],
        };
      }).filter(Boolean);

      payloadItems.filter(item => !stateItemsMap[`${item.type}=${item.slug}`]).forEach((item) => {
        const { type, slug, levelId, required, mode, not } = item;
        const cacheKey = `${type}=${slug}`;

        if (state.known[cacheKey]) {
          cacheItems.push({
            ...state.known[cacheKey],
            levelId,
            required,
            mode,
            not
          });
        }
      });

      return {
        ...state,
        page: ~~params.page || 1,
        sort: params.sort,
        items: cacheItems
      };
    }
    case SEARCH_ITEM_ADD: {
      const item = action.payload;
      const key = `${item.type}=${(item.slug || encodeURIComponent(item.title)).toString().replace(/=[!-]?/g, '=')}`;

      if (state.known[key]) {
        return { ...state, id: null };
      }

      const newItem = { ...item, id: `${item.type}-${v4()}`, required: false };
      return {
        ...state,
        id: null,
        known: {
          ...state.known,
          [key]: newItem
        }
      };
    }
    case SEARCH_ITEMS_ADD: {
      return action.payload.reduce((acc, item) => {
        const key = `${item.type}=${(item.slug || encodeURIComponent(item.title)).toString().replace(/=[!-]?/g, '=')}`;

        if (acc.known[key]) {
          return { ...acc, id: null };
        }

        const newItem = { ...item, id: `${item.type}-${v4()}`, required: false };
        return {
          ...acc,
          id: null,
          known: {
            ...acc.known,
            [key]: newItem
          }
        };
      }, state);
    }
    case SEARCH_ITEMS_LOADING:
      return {
        ...state,
        loading: true
      };
    case SEARCH_ITEMS_LOADED: {
      const items = action.result.map(item => ({ ...item, id: `${item.type}-${v4()}` }));
      return {
        ...state,
        loading: false,
        page: action.payload.page,
        sort: action.payload.sort,
        items,
        known: items.reduce((acc, curr) => {
          const key = `${curr.type}=${(curr.slug || encodeURIComponent(curr.title)).toString().replace(/=[!-]?/g, '=')}`;
          acc[key] = curr;
          return acc;
        }, {})
      };
    }
    case SEARCH_ITEMS_LOAD_FAILED:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
}

export const actions = {
  addItem(item) {
    return {
      type: SEARCH_ITEM_ADD,
      payload: item
    };
  },
  addItems(items) {
    return {
      type: SEARCH_ITEMS_ADD,
      payload: items
    };
  },
  setSearchId(id) {
    return {
      type: SEARCH_SET_ID,
      payload: id
    };
  },
  syncWithLocation(items, params) {
    return {
      type: SEARCH_SYNC_WITH_LOCATION,
      payload: { items, params }
    };
  },
  loadItems(items, params) {
    if (items.length === 0) {
      return { type: 'VOID' };
    }

    return {
      type: SEARCH_ITEMS_LOAD,
      types: [SEARCH_ITEMS_LOADING, SEARCH_ITEMS_LOADED, SEARCH_ITEMS_LOAD_FAILED],
      payload: { page: ~~params.page || 1, sort: params.sort },
      callApi: client => client.post('/dials/search-items', { items }),
    };
  },
};

export const selectors = {
  getState(state) {
    return {
      ...state.jobSearch,
      items: (state.jobSearch.items || []).map(item => ({
        ...item,
        slug: item.slug !== null && item.slug !== undefined ? item.slug.toString() : item.slug,
      }))
    };
  }
};
